var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-tabs', {
    staticClass: "mb-30px",
    attrs: {
      "grow": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v("Title wrap")]), _c('v-tab', [_vm._v("Title")]), _c('v-tab', [_vm._v("Text")])], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('typography-title-wrap')], 1), _c('v-tab-item', [_c('typography-title')], 1), _c('v-tab-item', [_c('typography-text')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }